import React, { useState, useEffect, Fragment, Suspense, lazy, useRef } from "react"
import forEach from "lodash-es/forEach"
import find from "lodash-es/find"
import filter from "lodash-es/filter"
import cloneDeep from "lodash-es/cloneDeep"
import sortBy from "lodash-es/sortBy"
import map from "lodash-es/map"
import has from "lodash-es/has"
import get from "lodash-es/get"
import random from "lodash-es/random"
import numeral from "numeral"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons/faLocationArrow"
import { faCommentDollar } from "@fortawesome/free-solid-svg-icons/faCommentDollar"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope"
import { faFilePdf } from "@fortawesome/free-solid-svg-icons/faFilePdf"
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes"
import { faHeart as faHeartFilled } from "@fortawesome/free-solid-svg-icons/faHeart"
import { faHeart } from "@fortawesome/free-regular-svg-icons/faHeart"
import { faShareSquare } from "@fortawesome/free-solid-svg-icons/faShareSquare"
import { faCheckCircle as faCheckCircleRegular } from "@fortawesome/free-regular-svg-icons/faCheckCircle"
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle"
import { faBinoculars } from "@fortawesome/free-solid-svg-icons/faBinoculars"
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo"
import { Modal } from "react-responsive-modal"
import "react-image-lightbox/style.css"
import "/scss/PublicMap.scss"
import Lightbox from "react-image-lightbox"
import { useStoreState, useStoreActions } from "easy-peasy"
import markerColors from "/lib/markerColors"
import NumberFormat from "react-number-format"
import axios from "axios"
import LazyLoad from "react-lazy-load"
import { formatPhoneNumber, getDateXDaysAgo, hasNumeric } from "/lib/helpers"
import * as dayjs from "dayjs"
import { fireEvent } from "/lib/helpers"
import PublicMap from "/components/PublicMap"
import decode from "entity-decode"
import "react-responsive-modal/styles.css"
import classNames from "classnames"

const DirectionsModule = lazy(() => import("./DirectionsModule"))

function PublicList(props) {
	const setActiveLot = useStoreActions((actions) => actions.setActiveLot)
	const showMap = useStoreState((state) => state.showMap)
	const manualMapShow = useStoreState((state) => state.manualMapShow)
	const setShowMap = useStoreActions((actions) => actions.setShowMap)
	const setContactOpen = useStoreActions((actions) => actions.setContactOpen)
	const setViewing = useStoreActions((actions) => actions.setViewing)
	const viewing = useStoreState((state) => state.viewing)
	const domain = useStoreState((state) => state.domain)
	const pipsyClient = useStoreState((state) => state.pipsyClient)
	const propertyID = useStoreState((state) => state.propertyID)
	const favorites = useStoreState((state) => state.favorites)
	const moveIn = useStoreState((state) => state.moveIn)
	const underConst = useStoreState((state) => state.underConst)
	const premiumHomesites = useStoreState((state) => state.premiumHomesites)
	const builderOwnedHomesites = useStoreState((state) => state.builderOwnedHomesites)
	const activeLot = useStoreState((state) => state.activeLot)
	const viewingFavorites = useStoreState((state) => state.viewingFavorites)
	const matchedList = useStoreState((state) => state.matchedList)
	const setManualMapShow = useStoreActions((actions) => actions.setManualMapShow)
	const mode = useStoreState((state) => state.mode)
	const activePanel = useStoreState((state) => state.activePanel)
	const setActivePanel = useStoreActions((actions) => actions.setActivePanel)
	const setScrollPos = useStoreActions((actions) => actions.setScrollPos)
	const setLotOpenType = useStoreActions((actions) => actions.setLotOpenType)
	const setFlyBack = useStoreActions((actions) => actions.setFlyBack)
	const setMobileContactOpen = useStoreActions((actions) => actions.setMobileContactOpen)
	const scrollPos = useStoreState((state) => state.scrollPos)
	const selections = useStoreState((state) => state.selections)
	const lotOpenType = useStoreState((state) => state.lotOpenType)
	const isMobile = useStoreState((state) => state.isMobile)
	const largeDevice = useStoreState((state) => state.largeDevice)
	const lastEvent = useStoreState((state) => state.lastEvent)
	const selectedAreaFeatures = useStoreState((state) => state.selectedAreaFeatures)
	const setLastEvent = useStoreActions((actions) => actions.setLastEvent)
	const setListHover = useStoreActions((actions) => actions.setListHover)
	const setMoveIn = useStoreActions((actions) => actions.setMoveIn)
	const setUnderConst = useStoreActions((actions) => actions.setUnderConst)
	const setPremiumHomesites = useStoreActions((actions) => actions.setPremiumHomesites)
	const setBuilderOwnedHomesites = useStoreActions((actions) => actions.setBuilderOwnedHomesites)
	const [lot, setLot] = useState({})
	const [directionsModalOpen, setDirectionsModalOpen] = useState(false)
	const [simpleText, setSimpleText] = useState(false)
	const [imageOpen, setImageOpen] = useState(false)
	const [imageIndex, setImageIndex] = useState(0)
	const [blueprintIndex, setBlueprintIndex] = useState(0)
	const [blueprintsOpen, setBlueprintsOpen] = useState(false)
	const [floorplanImages, setFloorplanImages] = useState([])
	const [floorplanIndex, setFloorplanIndex] = useState(0) // these two are for lot finder clicking a floorplan, brings up that gallery
	const [floorplanOpen, setFloorplanOpen] = useState(false)
	const [lastID, setLastID] = useState(false)
	const [virtualModal, setVirtualModal] = useState(false)
	const [virtualLink, setVirtualLink] = useState("")
	const [shareText, setShareText] = useState("SHARE URL")
	const [disabledNeighborhood, setDisabledNeighborhood] = useState(false)
	const [sort, setSort] = useState(props?.data?.custom?.personalize?.defaultSort || "Price")
	const [sortMenuOpen, setSortMenuOpen] = useState(false)

	let noBuilder = props?.data?.property?.enabled?.noBuilder // This is for the likes of willowcreek, selling lots directly to prospects community wide
	let dirtPricing = props?.data?.property?.enabled?.dirtPricing // For mixed communities where some is dirt and some is normal builder.  This ...may be the same as above?
	let list = React.useRef(null)
	const hoverIntentTimeout = useRef(null)
	const lastHoveredItem = useRef(null)

	const Missing = ({ children }) => (
		<div className="bg-[#eee] text-[#444] absolute left-0 top-0 w-full h-full flex justify-center items-center text-[12px]">
			{children}
		</div>
	)
	const Address = ({ children }) => (
		<span
			className={`font-bold uppercase flex pt-2 justify-between ${
				props.theme.secondaryEnabled ? props.theme.secondary_color : props.theme.color
			}`}>
			{children}
		</span>
	)

	const BadgeContainer = ({ children }) => <div className="absolute left-0 top-0 z-10">{children}</div>

	const OpenHouse = ({ children }) => (
		<div className="bg-[#10ad2a] absolute left-0 bottom-0 text-white text-[14px] p-[5px_15px] w-full box-border">
			{children}
		</div>
	)

	const OpenHouseIncentive = ({ children }) => (
		<div className="bg-[#10ad2a] text-white text-[14px] p-[8px_15px] w-full box-border lg:text-[16px] lg:flex lg:justify-between lg:items-center">
			{children}
		</div>
	)

	const OpenHouseNotes = ({ children }) => (
		<div className="border-l-[1px] border-r-[1px] border-b-[1px] border-[#10ad2a] text-[#222] text-[14px] p-[10px_15px]">
			{children}
		</div>
	)

	const TypeSelect = ({ children, activePanel }) => (
		<div
			className={`pipsy__typeSelect m-[0_0_15px_0] border-t-[1px] border-[#ccc] flex-wrap ${
				activePanel === false ? "block" : "hidden"
			} lg:flex lg:m-[0_0_5px_0] xl:m-[0_0_15px_0]`}>
			{children}
		</div>
	)

	const Count = ({ children }) => (
		<span className="p-[2px] bg-[#ccc] text-[#333] ml-[10px] text-[11px] font-bold xl:text-[13px] xl:p-[5px inline">
			{children}
		</span>
	)

	const HomesOptions = ({ children, activePanel }) => (
		<div
			className={`m-0 p-[0_20px_10px] text-[12px] justify-between ${
				activePanel === false ? "block" : "hidden"
			} lg:p-[0_20px_0] xl:flex xl:text-[14px] xl:p-[0_30px_10px]`}>
			{children}
		</div>
	)

	const HomeOptionsBox = ({ children }) => <div className="flex items-center pt-[10px]">{children}</div>

	const HomesOption = ({ children, onClick }) => (
		<div
			className="p-[10px_12px_10px] cursor-pointer border-[1px] border-[#ccc] mr-[8px] lg:p-[10px_20px_10px] [&>svg]:mr-1"
			onClick={onClick}>
			{children}
		</div>
	)

	const DownloadCalendar = ({ children }) => <div className="text-[12px] underline cursor-pointer">{children}</div>

	const Panel = ({ children, activePanel }) => (
		<div
			className={`min-h-full w-full contain-content ${
				activePanel ? "opacity-100 z-[100]" : "opacity-0 z-[-5]"
			} bg-[#fffcfa] relative`}>
			{children}
		</div>
	)

	const StickyClose = ({ children }) => <div className="sticky h-0 overflow-visible z-[10] top-0">{children}</div>

	const TitleContainer = ({ children }) => <div className="mt-[15px] lg:flex lg:justify-between">{children}</div>

	const Container = ({ children }) => <div className="p-[15px_20px]">{children}</div>

	const Spec = ({ children }) => <div className="p-[5px_15px_10px] flex-1">{children}</div>

	const SpecTitle = ({ children }) => (
		<p className="text-[14px] text-[#999] m-0 text-center lg:text-left">{children}</p>
	)

	const SpecInfo = ({ children }) => (
		<p className="font-bold text-[24px] mt-[5px] text-center lg:text-left">{children}</p>
	)

	const RequestRight = ({ children }) => (
		<div className="lg:flex lg:justify-end lg:items-center lg:flex-1">{children}</div>
	)

	const RequestButton = ({ children, onClick, theme }) => (
		<button
			onClick={onClick}
			className={`${
				props.theme.secondary_color ? `bg-secondary` : `bg-primary`
			} text-white py-3 text-base px-4 cursor-pointer border-0 transition-all duration-400 hover:bg-opacity-80 hover:text-gray-300 pipsy__requestInfoButton`}>
			{children}
		</button>
	)

	const Actions = ({ children }) => (
		<div className="pipsy__actions border border-gray-400 my-5 grid grid-cols-1 lg:grid-cols-3">{children}</div>
	)

	const CTA = ({ children, brandColors, theme, className, onClick }) => (
		<div
			onClick={onClick}
			className={`flex-1 text-sm py-4 px-4 transition-all duration-450 relative cursor-pointer ${className} ${
				brandColors
					? `${props.theme.secondary_color ? `bg-secondary` : `bg-primary`} text-white`
					: "bg-transparent text-gray-700"
			} hover:bg-gray-800 hover:text-white [&>svg]:mr-1 lg:border-r lg:border-r-[#bbb] last:border-r-0 [&:nth-child(-n+3)]:border-b [&:nth-child(-n+3)]:border-b-[#bbb]`}>
			{children}
		</div>
	)

	const FPLink = ({ children, href }) => (
		<a href={href} className="text-gray-700 no-underline w-full block">
			{children}
		</a>
	)

	const Copy = ({ children }) => <div className="bg-white shadow-md p-6 text-sm text-gray-700 my-10">{children}</div>

	const SalespersonTitle = ({ children }) => <p className="text-lg mb-4 text-gray-300">{children}</p>

	const SalespersonName = ({ children }) => <span className="inline-block pr-5 text-white text-lg">{children}</span>

	const ModelBlock = ({ children }) => <div>{children}</div>

	const HoursTitle = ({ children }) => <h3 className={`text-2xl text-${props.theme.color} mb-2 mt-4`}>{children}</h3>

	const Hours = ({ children }) => <p className="text-sm mt-0">{children}</p>

	const TextSubmit = ({ children, onClick }) => (
		<button className="bg-black text-white p-1.5 border-0 text-xs ml-1.5 cursor-pointer" onClick={onClick}>
			{children}
		</button>
	)

	const FullImage = ({ url, onClick }) => (
		<div
			className={`!h-[40vh] bg-cover bg-center cursor-pointer relative ${
				props?.theme?.noMap ? "h-[60vh] bg-contain bg-no-repeat bg-black" : ""
			}`}
			style={{ backgroundImage: `url("${url}")` }}
			onClick={onClick}
		/>
	)

	const NoResults = ({ children }) => <p className="text-xs text-gray-300 text-center py-7.5">{children}</p>

	const Incentive = ({ children }) => <p className="text-xs mb-0.5 relative z-125">{children}</p>

	const IncentiveLink = ({ children, href }) => (
		<a
			className="no-underline text-black transition-colors duration-200 ease-out hover:text-gray-400"
			target="_blank"
			href={href}>
			{children}
		</a>
	)

	const IncentiveDetail = ({ children }) => <p className="text-base mb-0.5">{children}</p>

	const IncentiveDetailBlock = ({ children }) => (
		<div className="px-2.5 py-1 border border-dashed border-gray-600">{children}</div>
	)

	const IncentiveTitle = ({ children }) => (
		<h3 className="text-current font-normal mb-2.5 mt-1 text-lg">{children}</h3>
	)

	const AmenityCategory = ({ children }) => <span>{children}</span>

	const AmenityColor = ({ color }) => (
		<i className="inline-block rounded-full mr-1.5 w-2.5 h-2.5" style={{ backgroundColor: color }}></i>
	)

	const AmenityDistance = ({ children }) => (
		<span className="text-xs text-gray-800 whitespace-nowrap">{children}</span>
	)

	const ViewVirtualTour = ({ children, onClick }) => (
		<div
			className="pipsy__viewVirtualTour bg-gray-800 p-2.5 text-white text-sm w-full box-border cursor-pointer flex items-center"
			onClick={onClick}>
			{children}
		</div>
	)

	const FrameContainer = ({ children }) => <div className="w-full h-full p-5 box-border">{children}</div>

	const LotPlansBlock = ({ children }) => <div>{children}</div>

	const LotPlansTitle = ({ children }) => (
		<h3
			className={`bg-${
				props.theme.secondaryEnabled ? props.theme.secondary_color : props.theme.color
			} text-white text-lg p-1.5 font-normal mt-3.5`}>
			{children}
		</h3>
	)
	const LotPlansList = ({ children }) => <ul className="flex flex-wrap list-none m-0 p-0">{children}</ul>

	const LotPlan = ({ children }) => <li className="w-1/2 mb-7.5 p-2.5 box-border">{children}</li>

	const LotPlanInfo = ({ children }) => <div className="text-xs pr-5">{children}</div>

	const LotPlanName = ({ children }) => (
		<div className={`font-bold text-lg mb-0.5 pt-2.5 text-${props.theme.color}`}>{children}</div>
	)

	const LotPlanFeatures = ({ children }) => (
		<ul className="list-none flex m-0 p-0 flex-wrap [&>li]:w-1/2 [&>li]:p-2 [&>li]:box-border [&>li:nth-child(4n)]:bg-gray-100 [&>li:nth-child(4n-1)]:bg-gray-100 [&>li:nth-child(4n)]:border-y [&>li:nth-child(4n-1)]:border-y [&>li:nth-child(4n)]:border-gray-200 [&>li:nth-child(4n-1)]:border-gray-200">
			{children}
		</ul>
	)

	const LotFinderInfo = ({ children }) => <span className="text-[14px]">{children}</span>

	const DirtPrice = ({ children }) => <div className="text-lg font-bold py-3.5">{children}</div>

	const TextingModule = (props) => {
		const [cellPhone, setCellPhone] = useState("")
		const favorites = useStoreState((state) => state.favorites)
		const allHomes = useStoreState((state) => state.allHomes)
		const activeLot = useStoreState((state) => state.activeLot)
		const pipsyClient = useStoreState((state) => state.pipsyClient)
		const domain = useStoreState((state) => state.domain)
		const [temp, setTemp] = useState(false)

		const textUser = () => {
			let favs = favorites || []
			let ret = []
			let f = []
			if (cellPhone.length !== 10) {
				alert("Invalid Phone Number.  Please correct and try again.")
				return
			}
			if (props.simple) {
				// simple is just to one address
				let ll = `${activeLot.latitude},${activeLot.longitude}`
				axios
					.post(`${domain}/textDirections`, {
						data: ll,
						cell: cellPhone,
						c: pipsyClient,
						property: props.property.id,
						propertyName: props.property.name,
						simple: true,
					})
					.then(function (response) {
						setTemp(true)
						setTimeout(() => {
							props.onChange(false)
						}, 3000)
					})
			} else {
				// favorites
				forEach(favs, (r) => {
					if (r.includes("f-")) return
					let str = r.replace("h-", "")
					str = parseInt(str)
					ret.push(str)
				})
				// Now get lat/lng for each
				forEach(ret, (v) => {
					let info = find(allHomes, { id: v })
					if (info) {
						f.push(`${info.latitude},${info.longitude}`)
					}
				})
				if (navigator.geolocation) {
					// To get route dirs, we need the users location to calculate best route..unfortunate.
					let success = (pos) => {
						if (pos.coords && pos.coords.latitude) {
							axios
								.post(`${domain}/textDirections`, {
									data: JSON.stringify(f),
									cell: cellPhone,
									c: pipsyClient,
									property: props.property.id,
									propertyName: props.property.name,
									lat: pos.coords.latitude,
									lng: pos.coords.longitude,
								})
								.then(function (response) {
									setTemp(true)
									setTimeout(() => {
										props.onChange(false)
									}, 3000)
								})
						}
					}
					let error = (err) => {
						console.log(err)
						alert("Location information has been blocked by your browser.")
					}
					navigator.geolocation.getCurrentPosition(success, error)
				}
			}
		}
		if (props.simple && temp) {
			return (
				<>
					<p style={{ margin: 0 }}>Text sent!</p>
				</>
			)
		}
		if (!props.simple && temp) {
			return (
				<>
					<p>Text message with directions has been sent!</p>
				</>
			)
		}
		return (
			<>
				<NumberFormat
					name="phone"
					format="+1 (###) ###-####"
					placeholder="Cell Phone"
					onValueChange={(v) => setCellPhone(v.value)}
					className="border border-slate-300 p-1 text-black"
				/>
				<TextSubmit
					onClick={() => {
						textUser()
					}}>
					SUBMIT
				</TextSubmit>
			</>
		)
	}

	const TextingFavorites = (props) => {
		const [cellPhone, setCellPhone] = useState("")
		const favorites = useStoreState((state) => state.favorites)
		const pipsyClient = useStoreState((state) => state.pipsyClient)
		const domain = useStoreState((state) => state.domain)
		const [temp, setTemp] = useState(false)

		const textUser = () => {
			if (cellPhone.length !== 10) {
				alert("Invalid Phone Number.  Please correct and try again.")
				return
			}
			axios
				.post(`${domain}/textFavorites`, {
					cell: cellPhone,
					c: pipsyClient,
					property: props.property,
					favorites,
				})
				.then(function (response) {
					setTemp(true)
					setTimeout(() => {
						props.onChange(false)
					}, 3000)
				})
		}
		if (temp) {
			return (
				<>
					<p style={{ margin: 0 }}>Text sent!</p>
				</>
			)
		}
		return (
			<>
				<NumberFormat
					name="phone"
					format="+1 (###) ###-####"
					placeholder="Cell Phone"
					onValueChange={(v) => setCellPhone(v.value)}
					style={{ border: "1px solid #999", padding: "1px 5px" }}
				/>
				<TextSubmit
					onClick={() => {
						textUser()
					}}>
					SUBMIT
				</TextSubmit>
			</>
		)
	}

	const Acreage = ({ children }) => <div className="text-[15px] py-[10px] pb-[15px]">{children}</div>

	const AvailableHomesite = ({ children }) => <div className="text-[14px] my-[10px]">{children}</div>

	const Image = ({ v, ...props }) => (
		<div
			className="w-full h-[22vh] bg-cover bg-center relative cursor-pointer"
			style={{ backgroundImage: `url("${v.images?.[0] || v.image || ""})"` }}
			{...props}
		/>
	)

	useEffect(() => {
		console.log("Pipsy: Mounting Public List..")
		let disabledNeighborhood = props.data.custom && props.data.custom.disabledNeighborhood
		setDisabledNeighborhood(disabledNeighborhood)
		let params = new URLSearchParams(window.location.search)
		let deep = {
			moveIn: params.get("moveIn"),
			underConstruction: params.get("underConstruction"),
		}
		if (deep.moveIn) {
			setUnderConst(false)
		} else if (deep.underConstruction) {
			setMoveIn(false)
		}
		return () => {
			console.log("Pipsy: Unmounting Public List..")
			// Clear any pending timeouts or subscriptions
			if (hoverIntentTimeout.current) {
				clearTimeout(hoverIntentTimeout.current)
			}
		}
	}, [])

	//? Commented this out because it was shooting the inventory to the top of the list when opening sort.  Not sure why it was here.
	/* useEffect(() => {
		let isSubscribed = true
		if (!activePanel && list?.current && isSubscribed) {
			try {
				//list.current.scrollTop = scrollPos
			} catch (e) {
				console.log(e)
			}
		}

		return () => {
			isSubscribed = false
		}
	}) */

	useEffect(() => {
		let isSubscribed = true

		if (isSubscribed) {
			props.buildMatchLists()
		}

		return () => {
			isSubscribed = false
		}
	}, [selections, moveIn, underConst, viewing, viewingFavorites, favorites, premiumHomesites, builderOwnedHomesites])

	useEffect(() => {
		let isSubscribed = true

		if (isMobile && lotOpenType === "list" && isSubscribed) {
			let el = document.querySelector('[data-id="' + lastID + '"]')
			if (el) {
				const y = el.getBoundingClientRect().top + window.pageYOffset - 80
				window.scrollTo({ top: y })
			}
		} else if (isMobile && lotOpenType === "map" && isSubscribed) {
			let el = document.getElementById("pipsy__map")
			if (el) {
				const y = el.getBoundingClientRect().top + window.pageYOffset - 40
				window.scrollTo({ top: y })
			}
		}

		return () => {
			isSubscribed = false
		}
	}, [activePanel])

	const ctaTabs = (v) => {
		let lookup = get(props, "data.property.enabled.ctaTabs")
		if (lookup) {
			if (viewing === "floorplans") {
				let box = (
					<a href={`${lookup.floorplan_link}/${v.id}`} target="_blank" className="z-[200]">
						{lookup.floorplan}
					</a>
				)
				return <p className="pipsy__ctaTab">{box}</p>
			} else if (["homes", "models"].includes(viewing)) {
				let box = (
					<a href={`${lookup.home_link}/${v.id}`} target="_blank" className="z-[200]">
						{lookup.home}
					</a>
				)
				return <p className="pipsy__ctaTab">{box}</p>
			}
		}
		return null
	}

	const requestInfoCardButtons = (v) => {
		if (["area_features", "amenities"].includes(viewing)) return null
		let d = get(props, "data.property.enabled.requestInfoCardButtons")
		if (d) {
			return (
				<div className="relative z-[110]">
					<div
						className="pipsy__requestInfoCard text-white bg-primary p-2 inline-block text-sm rounded-sm cursor-pointer"
						onClick={() => {
							openItem(v.id)
							openContact()
						}}>
						{d.text}
					</div>
				</div>
			)
		}
		return ""
	}

	let BuildList = () => {
		let arr = []
		//? Does every developer want move in ready always first?
		//let set = sortBy(matchedList, ["lot_status", "price"])
		let defaultSort = "price"
		let translate = [
			{
				value: "price",
				name: "Price",
			},
			{
				value: "sqft",
				name: "Square Footage",
			},
			{
				value: "beds",
				name: "Beds",
			},
			{
				value: "stories",
				name: "Stories",
			},
			{
				value: "move_in_date",
				name: "Move In Date",
			},
		]
		let lookup = find(translate, { name: sort })
		if (lookup) defaultSort = lookup.value
		let set = sortBy(matchedList, [defaultSort])
		let amenityColor
		if (viewing == "amenities" || viewing == "area_features") {
			set = sortBy(set, "distance")
		}
		// End sorting by available home first
		forEach(set, (v) => {
			let favoriteID = viewing == "floorplans" ? `f-${v.id}` : `h-${v.id}`
			if (viewing == "amenities" || viewing == "area_features") {
				try {
					if (!selectedAreaFeatures.includes(v.category)) return
					if (markerColors[v.category]) amenityColor = markerColors[v.category]
				} catch (e) {
					console.log(e)
				}
			}
			let incentive
			try {
				if (v.incentive && v.incentive.length > 0) {
					incentive = []
					forEach(v.incentive, (i, k) => {
						let url
						if (i.url) url = i.url
						else if (i.pdf) url = i.pdf
						incentive.push(
							<Incentive key={`${v.id}-${k}`}>
								<FontAwesomeIcon icon={faCommentDollar} color={"#34a32e"} style={{ marginRight: 5 }} />
								{url ? (
									<IncentiveLink href={url} target="_blank">
										{i.incentive}
									</IncentiveLink>
								) : (
									<span style={{ marginLeft: 5 }}>{i.incentive}</span>
								)}
							</Incentive>
						)
					})
				}
			} catch (e) {
				console.log(e)
			}
			let distance
			if (v.distance) {
				distance = `${v.distance} miles`
			}
			let availNow
			let openHouse
			let newModel
			let missing
			let virtual
			let availType = ""
			if (props?.data?.property?.forceLotStatusByMoveInDate) {
				//? This was a request from Johnson to not use complete date.  Not sure it makes sense for everyone.
				//if (v.complete_date) availNow = "Available Now"
				if (v.move_in_date && v.move_in_date < Math.floor(Date.now() / 1000)) {
					// If this is a model, make sure it's in_feed or in_feed_manual
					if (viewing === "models" && !v.in_feed && !v.in_feed_manual) availNow = null
					else availNow = "Available Now"
				} else if (v.move_in_date && v.move_in_date > Math.floor(Date.now() / 1000)) {
					if (viewing === "models" && !v.in_feed && !v.in_feed_manual) availNow = null
					else availNow = "Available " + dayjs(v.move_in_date * 1000).format("MMMM YYYY")
				}
			} else if (!v.model) {
				// Using complete date for available now.  If it has a move in date, then put available tag.
				if (viewing === "models" && !v.in_feed && !v.in_feed_manual) availNow = null
				else if (v.complete_date) {
					availNow = "Available Now"
					availType = "moveInReady"
				} else if (v.move_in_date && v.move_in_date < Math.floor(Date.now() / 1000)) {
					availNow = "Coming Soon "
					availType = "comingSoon"
				} else if (v.move_in_date && v.move_in_date > Math.floor(Date.now() / 1000)) {
					availNow = "Available " + dayjs(v.move_in_date * 1000).format("MMMM YYYY")
					availType = "comingSoon"
				}
			}

			try {
				let ninetyDays = getDateXDaysAgo(90).getTime() / 1000
				if (v.model && v.complete_date > ninetyDays && !props?.data?.custom?.personalize?.noNewModelText) {
					newModel = `New Model`
					if (props?.data?.custom?.newModelText) {
						newModel = props?.data?.custom?.newModelText
					}
				}
			} catch (e) {
				console.log(e)
			}
			// open house
			try {
				if (v.open_house && typeof Array.isArray(v.open_house) && v.open_house.length > 0) {
					let text = Array.isArray(v.open_house) ? v.open_house[0].text : ""
					openHouse = (
						<OpenHouse>
							<strong>Open House: </strong>
							{text}
						</OpenHouse>
					)
				}
			} catch (e) {
				console.log(e)
			}
			// missing image
			let hasMissing = <Missing className="pipsy__missingImage">No Image Available</Missing>
			if (props?.data?.property?.noImage) {
				missing = (
					<div
						style={{ backgroundImage: `url(${props?.data?.property?.noImage})` }}
						className="bg-[#eee] bg-cover bg-center absolute left-0 top-0 w-full h-full z-[-100] flex justify-center items-center text-[12px]"
					/>
				)
			} else if (!["area_features", "amenities"].includes(viewing) && (!v.images || v.images.length == 0)) {
				// if you're not looking at area features or amenities, then it should have images
				missing = hasMissing
			} else if (["area_features", "amenities"].includes(viewing) && !v.image) {
				// Looking at area features or amenities, it should just be a singular image
				missing = hasMissing
			}
			if (v.virtual && !openHouse) {
				//? make sure this goes after the open house logic.  open house overrides virtual in the list view
				virtual = (
					<div className="pipsy__virtualTourAvailable bg-green-600 absolute left-0 bottom-0 p-1.5 text-white text-sm w-full box-border">
						Virtual Tour Available
					</div>
				)
			}
			let baths = ""
			if (v.full_baths) baths += `${v.full_baths} full baths`
			if (v.half_baths && v.full_baths) baths += ` | `
			if (v.half_baths) baths += `${v.half_baths} half baths`
			//? If this home doesn't have a picture, see if we can pull an elevation from the floorlpan, if any.
			try {
				if (!v.images || v.images.length == 0) {
					if (v?.floorplan?.id) {
						let fpLookup = find(props.data.floorplans, { id: v.floorplan.id })
						if (fpLookup?.files?.length > 0) {
							// check if this is an array of objects or array of urls
							if (typeof fpLookup.files[0] == "object") {
								fpLookup.files = fpLookup.files.map((f) => f.url)
							}
							v.images = fpLookup.files
						}
					}
				}
			} catch (e) {
				console.log(e)
			}
			//? This is the for Airia manual construction status. The snipes should be whatever the manual status calls for.
			try {
				if (v.manual_construction_status) {
					let s = v.manual_construction_status
					if (s === "under_construction") {
						availNow = "Under Construction"
						availType = "underConstruction"
					} else if (s === "completed") {
						availNow = "Available Now"
						availType = "moveInReady"
					} else if (s === "dirt") {
						availNow = "Coming Soon"
						availType = "comingSoon"
					}
				}
			} catch (error) {
				console.log(error)
			}
			let img = (
				<LazyLoad height={`22vh`} style={{ overflow: "hidden" }}>
					<Image v={v}>
						<BadgeContainer>
							{availNow && (
								<div
									className={`pipsy__availableNow pipsy__availableNow--${availType} ${
										props?.theme?.accent_color ? "bg-accent" : "bg-[#333]"
									} text-white text-[14px] p-[5px_15px] box-border`}>
									{availNow}
								</div>
							)}
							{newModel && (
								<div className="pipsy__newModel bg-[#c50028] text-white text-[14px] p-[5px_15px] box-border">
									{newModel}
								</div>
							)}
						</BadgeContainer>
						{!v.images || v?.images?.length === 0 ? missing : null}
						{openHouse}
						{virtual}
					</Image>
				</LazyLoad>
			)
			let lotPhotos = get(props, "data.property.enabled.lotPhotos")
			if (props?.data?.property?.disabled?.amenityPhotos && viewing == "area_features") img = null
			else if (viewing === "lot_finder" && !noBuilder && !lotPhotos) img = null
			let type = ""
			if (["homes", "openHouses", "models"].includes(viewing)) {
				type = "home"
			} else if (viewing === "floorplans") type = "floorplan"
			else if (["amenities", "area_features"].includes(viewing)) type = "amenity"
			else if (viewing === "lot_finder") type = "lot"
			//? This is for the hover intent
			const handleHoverIntent = (v) => {
				if (isMobile) return
				if (hoverIntentTimeout.current) {
					clearTimeout(hoverIntentTimeout.current)
				}
				lastHoveredItem.current = v
				hoverIntentTimeout.current = setTimeout(() => {
					if (lastHoveredItem.current === v) {
						setListHover(v)
					}
				}, 100)
			}

			const handleMouseLeave = () => {
				if (isMobile) return
				if (hoverIntentTimeout.current) {
					clearTimeout(hoverIntentTimeout.current)
				}
				lastHoveredItem.current = null
				setListHover(null)
			}
			let address
			if (["homes", "openHouses", "models", "lot_finder"].includes(viewing)) {
				if (props?.data?.property?.enabled?.lotFinderUseLBS && viewing === "lot_finder") {
					address = `Lot ${v.lot}, Block ${v.block}, ${v.address}`
				} else {
					address = v.address
				}
			}
			arr.push(
				<li
					key={`${v.id} - ${random(0, 9999)}`}
					onMouseEnter={() => handleHoverIntent(v)}
					onMouseLeave={handleMouseLeave}
					data-id={v.id}
					data-name={`${["homes", "openHouses", "models"].includes(viewing) ? v.address : v.name}`}
					data-type={type}
					className="pipsy__item border-b border-current p-2.5 lg:p-3.5 relative z-5 m-2.5">
					<div
						onClick={() => openItem(v.id)}
						className="pipsy__itemAction absolute left-0 top-0 w-full h-full z-[100] cursor-pointer"
					/>
					{viewing !== "amenities" && viewing !== "area_features" && (
						<div className="absolute right-2 z-[170] cursor-pointer p-2.5">
							{!favorites.includes(favoriteID) && (
								<FontAwesomeIcon
									icon={faHeart}
									color={"#e63702"}
									className="pipsy__favorite"
									onClick={() => {
										setScrollPos(list.current.scrollTop)
										props.storeFavorite(favoriteID)
										fireEvent(
											{
												type: "favorite",
												data: viewing == "homes" ? v.address : v.name,
												name: viewing == "homes" ? v.address : v.name,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}
								/>
							)}
							{favorites.includes(favoriteID) && (
								<FontAwesomeIcon
									icon={faHeartFilled}
									color={"#e63702"}
									className="pipsy__unfavorite"
									onClick={() => {
										setScrollPos(list.current.scrollTop)
										props.removeFavorite(favoriteID)
										fireEvent(
											{
												type: "unfavorite",
												data: viewing == "homes" ? v.address : v.name,
												name: "homes" ? v.address : v.name,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}
								/>
							)}
						</div>
					)}
					{/* This is causing flicking on render. */}
					{img}
					<p className="text-[15px] leading-[1.6em] !text-left">
						{v.is_premium && (
							<span
								className={`pipsy__premium text-white text-sm px-1 ${
									props.theme.secondaryEnabled ? props.theme.secondary_color : props.theme.color
								}`}>
								Premium Homesite
							</span>
						)}
						<span
							className={classNames(
								`pipsy__addressBlock font-bold uppercase flex pt-2 !justify-between`,
								{
									"text-secondary": props.theme.secondaryEnabled,
									"text-primary": !props.theme.secondaryEnabled,
								}
							)}>
							{address}
							{(viewing == "floorplans" && v.feed_name) || v.name}
							{viewing == "area_features" && distance && <AmenityDistance>{distance}</AmenityDistance>}
						</span>
						{["homes", "models"].includes(viewing) && !disabledNeighborhood && (
							<>
								{v.neighborhood}
								<br />
							</>
						)}

						{!!v.price && viewing !== "lot_finder" && (
							<>
								<strong className="pipsy__price">{numeral(v.price).format("$0,0")}</strong>
								<br />
							</>
						)}
						{v.builder_marketing_name || v.builder}
						{!["amenities", "area_features", "lot_finder"].includes(viewing) && (
							<>
								<br />
								{numeral(v.sqft).format("0,0")} sq ft | {v.beds} beds
								<br />
								{baths}
							</>
						)}
						{["lot_finder"].includes(viewing) && v.marketing_lot_type && (
							<LotFinderInfo>
								<br />
								Lot Size: {v.marketing_lot_type}
								{v.price ? (
									<>
										<br />
										Lot Price: {numeral(v.price).format("$0,0")}
									</>
								) : (
									""
								)}
								{v.acreage ? (
									<>
										<br />
										Acreage: {v.acreage}
									</>
								) : (
									""
								)}
							</LotFinderInfo>
						)}
						{(viewing == "amenities" || viewing == "area_features") && (
							<AmenityCategory>
								{amenityColor && <AmenityColor color={amenityColor}></AmenityColor>}
								{v.category}
							</AmenityCategory>
						)}
					</p>
					<div className="pipsy__ctaTabs z-[200] relative">{ctaTabs(v)}</div>
					{requestInfoCardButtons(v)}
					{viewing == "homes" && incentive && <>{incentive}</>}
				</li>
			)
		})
		return arr
	}

	let openGallery = (index) => {
		setImageOpen(true)
		setImageIndex(index)
	}

	let buildPanelImages = () => {
		try {
			if (typeof activeLot.images === "string") activeLot.images = JSON.parse(activeLot.images)
			if (!activeLot.images || activeLot.images.length === 0) {
				if (activeLot?.floorplan?.id) {
					let fpLookup = find(props.data.floorplans, { id: activeLot.floorplan.id })
					if (fpLookup?.files?.length > 0) {
						activeLot.images = fpLookup.files
					}
				}
			}
		} catch (e) {
			console.log(e)
		}
		let ret = map(activeLot.images, (v, k) => {
			let url = v
			if (typeof v === "object") {
				url = v.url
			}
			return <FullImage url={url} key={`fullImage-${v}`} onClick={() => openGallery(k)} />
		})
		return ret
	}

	let openItem = (id) => {
		if (viewing !== "amenities" && viewing !== "area_features") {
			setActivePanel(true)
		}
		setLotOpenType("list")
		setScrollPos(list.current.scrollTop)
		setLastID(id)

		if (["homes", "openHouses", "models"].includes(viewing)) {
			let lot = find(props.data.available, { id: id })
			// Sometimes we have models with prices that should be included, check that.
			if (!lot) {
				lot = find(props.data.models, { id })
			}
			setActiveLot(lot)
			setLot(lot)
			fireEvent(
				{
					type: "listLotClick",
					data: lot.address,
					name: null,
				},
				lastEvent,
				setLastEvent,
				{ domain, pipsyClient, propertyID }
			)
		} else if (viewing === "lot_finder") {
			let lot = find(props.data.mapLots, { id: id })
			setActiveLot(lot)
			setLot(lot)
			fireEvent(
				{
					type: "listLotClick",
					data: lot.address,
					name: null,
				},
				lastEvent,
				setLastEvent,
				{ domain, pipsyClient, propertyID }
			)
		} else if (viewing == "floorplans") {
			let fp = find(props.data.floorplans, { id: id })
			setActiveLot(fp)
			setLot(fp)
			fireEvent(
				{
					type: "listFloorplanClick",
					data: `${fp.name} - ${fp.builder}`,
					name: fp.name,
					builder: fp.builder_id,
				},
				lastEvent,
				setLastEvent,
				{ domain, pipsyClient, propertyID }
			)
		} else if (viewing == "amenities" || viewing == "area_features") {
			let f = find(props.data.area_features, { id })
			let amen = cloneDeep(f)
			amen.rand = random(1, 9999)
			setActiveLot(amen)
		}
		if (isMobile) {
			// Determine the pos of the pipsy container and move to there.
			try {
				const getDistanceFromTop = (element) => {
					const rect = element.getBoundingClientRect()
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop
					return rect.top + scrollTop
				}
				//let pos = document.querySelector(".pipsy__global").offsetTop
				//let pos = document.querySelector(".pipsy__global").getBoundingClientRect().top
				let pos = getDistanceFromTop(document.querySelector(".pipsy__global"))
				//console.log(`Mobile, moving to ${pos}`)
				window.scrollTo(0, pos)
			} catch (e) {
				console.warn(e)
			}
		}
	}

	let openContact = () => {
		if (get(props.data, `property.noMap`)) setMobileContactOpen(true)
		else if (largeDevice) setContactOpen(true)
		else setMobileContactOpen(true)
		fireEvent(
			{
				type: "requestInfoButton",
				data: activeLot.address || `${activeLot.name} - ${activeLot.builder}`,
				name: activeLot.address || `${activeLot.name} - ${activeLot.builder}`,
			},
			lastEvent,
			setLastEvent,
			{ domain, pipsyClient, propertyID }
		)
	}

	let closePanel = () => {
		setActiveLot(false)
		setActivePanel(false)
		setMobileContactOpen(false)
		setContactOpen(false)
	}

	const secondaryColor = () => {
		// Check if this property wants secondary colors, if so returns that color, if not then returns the default theme color
		if (get(props, `property.enabled.secondaryColor`)) return props.property.secondary_color
		return props.property.color
	}

	let GeneratePanel = () => {
		let moveIn = ""
		let virtual
		// First check the move in date
		if (activeLot.move_in_date && activeLot.move_in_date > Math.floor(Date.now() / 1000)) {
			moveIn = "Available " + dayjs(activeLot.move_in_date * 1000).format("MMMM YYYY")
		}
		// now check for Coming soon with no move in
		else if (activeLot.lot_status == "Coming Soon" && !activeLot.move_in_date) {
			moveIn = "Coming Soon"
		} else if (activeLot.model) moveIn = "Model"
		else if (activeLot.move_in_date && activeLot.move_in_date < Math.floor(Date.now() / 1000)) {
			moveIn = "Available Now"
		} else if (activeLot.complete_date) moveIn = "Available Now"
		//? This is the for Airia manual construction status. The snipes should be whatever the manual status calls for.
		try {
			if (activeLot.manual_construction_status) {
				let s = activeLot.manual_construction_status
				if (s === "under_construction") {
					moveIn = "Under Construction"
				} else if (s === "completed") {
					moveIn = "Available Now"
				} else if (s === "dirt") {
					moveIn = "Coming Soon"
				}
			}
		} catch (error) {
			console.log(error)
		}

		if (viewing == "homes" && has(activeLot, `floorplan.floorplan_images`)) {
			activeLot.floorplan_images = activeLot.floorplan.floorplan_images
		}
		let favoriteID = activeLot.address ? `h-${activeLot.id}` : `f-${activeLot.id}`
		let fromThe
		if (activeLot.model_from_the && parseInt(activeLot.model_from_the) && parseInt(activeLot.model_from_the) > 0) {
			let text = `${activeLot.model_from_the}'s`
			if (activeLot.model_from_the === 1000000) {
				text = "$1 Millions"
			}
			fromThe = <Hours>Starting from the {text}</Hours>
		}
		let incentive
		let openHouse
		try {
			if (activeLot.incentive && activeLot.incentive.length > 0) {
				incentive = []
				forEach(activeLot.incentive, (i, k) => {
					let url
					if (i.url) url = i.url
					else if (i.pdf) url = i.pdf
					incentive.push(
						<IncentiveDetail key={`${activeLot.id}-${k}`}>
							<FontAwesomeIcon icon={faCommentDollar} color={"#34a32e"} />
							{` `}
							{url ? (
								<IncentiveLink href={url}>{i.incentive}</IncentiveLink>
							) : (
								<span style={{ marginLeft: 5 }}>{i.incentive}</span>
							)}
						</IncentiveDetail>
					)
				})
			}
			if (activeLot.open_house && typeof Array.isArray(activeLot.open_house) && activeLot.open_house.length > 0) {
				let opens = []
				forEach(activeLot.open_house, (v) => {
					opens.push(
						<Fragment key={`openHouse-${v.endStamp}`}>
							<OpenHouseIncentive>
								<div>
									<strong>Open House</strong>: {v.text}
								</div>
								<DownloadCalendar
									onClick={() => {
										downloadCalendar(v)
										fireEvent(
											{
												type: "calendarInviteClick",
												data: activeLot.address,
												name: null,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}>
									Download Calendar Invite
								</DownloadCalendar>
							</OpenHouseIncentive>
							{v.notes && <OpenHouseNotes>{v.notes}</OpenHouseNotes>}
						</Fragment>
					)
				})
				if (opens.length > 0) openHouse = opens
				if (openHouse.length > 5) openHouse = openHouse.splice(0, 5)
			}
			if (activeLot.virtual) {
				virtual = (
					<ViewVirtualTour
						onClick={() => {
							fireEvent(
								{
									type: "virtualTour",
									data: activeLot?.address,
									name: activeLot?.address,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
							if (activeLot?.virtual?.includes("youtube") || activeLot?.virtual?.includes("google.com")) {
								window.open(activeLot?.virtual, "_blank")
								return
							}
							setVirtualLink(activeLot.virtual)
							setVirtualModal(true)
						}}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style={{ width: 28 }}>
							<path
								d="M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24h83.2L36 218.7c-4.9 7.4-5.4 16.8-1.2 24.6S47.1 256 56 256H88c30.9 0 56 25.1 56 56v40c0 26.5-21.5 48-48 48H94.5c-16 0-31-8-39.9-21.4L44 362.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l10.6 15.9C32.5 432 62.4 448 94.5 448H96c53 0 96-43 96-96V312c0-53.3-40-97.2-91.6-103.3L172 101.3c4.9-7.4 5.4-16.8 1.2-24.6S160.9 64 152 64H24zm440 80c0-17.7 14.3-32 32-32s32 14.3 32 32V368c0 17.7-14.3 32-32 32s-32-14.3-32-32V144zM576 368V144c0-44.2-35.8-80-80-80s-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80zM272 160c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96V288l0 .2V368c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-11.4 0-22.2 2.4-32 6.7V160zm32 80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V272c0-17.7 14.3-32 32-32z"
								fill="white"
							/>
						</svg>
						<span style={{ paddingLeft: 6 }}>View Virtual Tour</span>
					</ViewVirtualTour>
				)
			}
		} catch (e) {
			console.log(e)
		}
		if (activePanel) {
			let specBlock
			if (activeLot.lot_status === "Available Lot") {
			} else if (
				!activeLot.model ||
				(activeLot.price && !activeLot.sale_id && (activeLot.in_feed || activeLot.in_feed_manual))
			) {
				specBlock = (
					<div
						className={`pipsy__specBox bg-white shadow-[0px_0px_6px_rgba(0,0,0,0.2)] grid grid-cols-2 lg:p-[25px] lg:grid-cols-3 xl:grid-cols-4 ${
							noBuilder ? "hidden" : ""
						}`}>
						<Spec>
							<SpecTitle>PRICE</SpecTitle>
							<SpecInfo>{activeLot.price ? numeral(activeLot.price).format("$0,0") : "TBD"}</SpecInfo>
						</Spec>
						<Spec>
							<SpecTitle>SQ.FT</SpecTitle>
							<SpecInfo>{numeral(activeLot.sqft).format("0,0")}</SpecInfo>
						</Spec>
						<Spec>
							<SpecTitle>BEDS</SpecTitle>
							<SpecInfo>{numeral(activeLot.beds).format("0,0")}</SpecInfo>
						</Spec>
						<Spec>
							<SpecTitle>FULL BATHS</SpecTitle>
							<SpecInfo>{numeral(activeLot.full_baths).format("0,0")}</SpecInfo>
						</Spec>
						<Spec>
							<SpecTitle>HALF BATHS</SpecTitle>
							<SpecInfo>{numeral(activeLot.half_baths).format("0,0")}</SpecInfo>
						</Spec>
						<Spec>
							<SpecTitle>GARAGE</SpecTitle>
							<SpecInfo>{activeLot.garage ? numeral(activeLot.garage).format("0.0") : "N/A"}</SpecInfo>
						</Spec>
						<Spec>
							<SpecTitle>STORIES</SpecTitle>
							<SpecInfo>{activeLot.stories ? numeral(activeLot.stories).format("0.0") : "N/A"}</SpecInfo>
						</Spec>
					</div>
				)
			}
			let requestInfo
			let planName
			let dirtPrice // for direct dirt sales
			let acreage
			try {
				if ((noBuilder && activeLot.price) || (activeLot.price && dirtPricing))
					dirtPrice = <DirtPrice>{numeral(activeLot.price).format("$0,0")}</DirtPrice>
				if (noBuilder && activeLot.acreage) {
					acreage = (
						<>
							<Acreage>
								{activeLot.acreage} acres
								<br />
								<AvailableHomesite>
									<strong>Available Homesite</strong>
									<br />
									For more information please contact the sales representative.
								</AvailableHomesite>
							</Acreage>
						</>
					)
				}
			} catch (e) {
				console.log(e)
			}
			try {
				/* planName = activeLot?.floorplan?.feed_name
					? activeLot.floorplan.feed_name.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase())
					: "" */
				planName = activeLot?.floorplan?.feed_name || ""
			} catch (error) {
				console.log(error)
			}
			if (activeLot) {
				requestInfo = (
					<CTA className="pipsy__cta--requestInfo" brandColors={true} onClick={openContact}>
						<FontAwesomeIcon icon={faEnvelope} color={"#fff"} />
						{props?.data?.custom?.requestInfoButton || "REQUEST INFO"}
					</CTA>
				)
			}
			let images = buildPanelImages()
			let carousel = null
			if (images && images.length > 0) {
				carousel = (
					<Carousel showThumbs={false} showStatus={false} swipeable={false}>
						{images}
					</Carousel>
				)
			}
			let title = ""
			if (activeLot.address) title = activeLot.address
			else if (activeLot.feed_name) title = activeLot.feed_name
			else if (activeLot.name) title = activeLot.name

			//? Special logic for situations where there's an address, but on numeric chars, like Georges Ranch where address numbers aren't assigned until lot purchase.  In these cases, put the lot/block in front of the address.
			if (activeLot.address && !hasNumeric(activeLot.address)) {
				title = `Lot ${activeLot.lot}, Block ${activeLot.block}, ${title}`
			}
			return (
				<Panel activePanel={activePanel}>
					<StickyClose>
						<div
							onClick={closePanel}
							className="pipsy__close absolute top-0 right-[40px] text-[24px] text-white z-[150] font-bold cursor-pointer text-shadow-[2px_2px_black] bg-[rgba(0,0,0,0.7)] p-[8px_15px]">
							<FontAwesomeIcon icon={faTimes} />
						</div>
					</StickyClose>
					{carousel}
					<div className="bg-[rgba(0,0,0,0.8)] flex justify-between pipsy__moveInDate">
						<div className="text-white text-[18px] p-[8px_15px] pipsy__moveInText">{moveIn}</div>
					</div>
					<Container className="pipsy__listContainer">
						<TitleContainer>
							<div>
								<h2
									className={classNames(`!text-3xl mt-0 pipsy__detailTitle`, {
										"text-secondary": props.theme.secondaryEnabled,
										"text-primary": !props.theme.secondaryEnabled,
										"mb-0": lot.neighborhood,
										"mb-auto": !lot.neighborhood,
									})}>
									{title}
								</h2>
								{activeLot.neighborhood && !disabledNeighborhood && (
									<p className="text-gray-400 text-sm mb-5 mt-1 pipsy__neighborhoodName">
										in {activeLot.neighborhood}
									</p>
								)}
							</div>
							<RequestRight>
								<RequestButton onClick={openContact}>REQUEST INFO</RequestButton>
							</RequestRight>
						</TitleContainer>
						{incentive && (
							<>
								<IncentiveDetailBlock>
									<IncentiveTitle>Incentives</IncentiveTitle>
									{incentive}
								</IncentiveDetailBlock>
							</>
						)}
						<div
							className={classNames(
								`text-white text-lg py-1 px-4 mt-4 lg:flex lg:justify-between pipsy__builderName`,
								{
									"bg-secondary": props.theme.secondary_color,
									"bg-primary": !props.theme.secondary_color,
								}
							)}>
							<div>{activeLot.builder_marketing_name || activeLot.builder}</div>
							{planName && (
								<div className="text-sm lg:py-0 pipsy__floorplanName flex items-center">
									Plan: {planName}
								</div>
							)}
						</div>
						{virtual}
						{specBlock}
						{dirtPrice}
						{acreage}
						{activeLot.model && activeLot.model_hours && (
							<ModelBlock>
								<HoursTitle>Model Hours</HoursTitle>
								<Hours dangerouslySetInnerHTML={{ __html: activeLot.model_hours }}></Hours>
								{fromThe}
							</ModelBlock>
						)}
						{activeLot.marketing_salespeople && (
							<div className="pipsy__salespersonBlock bg-gray-800 p-4">
								<SalespersonTitle>Sales Representatives</SalespersonTitle>
								<ul className="pipsy__salespersonList m-0 p-0 list-none">
									{map(activeLot.marketing_salespeople, (v, k) => {
										return (
											<li
												className="mb-[10px] pb-[5px] border-b border-b-[#666]"
												key={`sps-${k}`}>
												<p className="text-white m-0">
													<SalespersonName>{v.name}</SalespersonName>
													{v.phone && (
														<span
															className="pipsy__salespersonPhone text-gray-300 text-sm"
															onClick={() => {
																fireEvent(
																	{
																		type: "phoneSalesperson",
																		data: v.phone,
																		name: activeLot.address,
																	},
																	lastEvent,
																	setLastEvent,
																	{ domain, pipsyClient, propertyID }
																)
															}}>
															<a
																href={`tel:1${v.phone}`}
																className="text-gray-300 no-underline border-b border-transparent hover:border-gray-300">
																{formatPhoneNumber(v.phone)}
															</a>
														</span>
													)}
													{v.email && !props?.data?.property?.disabled?.showEmails && (
														<span
															className="pipsy__salespersonEmail text-gray-300 text-sm pt-2 block lg:inline-block lg:pl-4"
															onClick={() => {
																fireEvent(
																	{
																		type: "emailSalesperson",
																		data: v.email,
																		name: activeLot.address,
																	},
																	lastEvent,
																	setLastEvent,
																	{ domain, pipsyClient, propertyID }
																)
															}}>
															<a
																href={`mailto:${v.email}`}
																className="text-gray-300 no-underline border-b border-transparent hover:border-gray-300">
																{v.email}
															</a>
														</span>
													)}
												</p>
											</li>
										)
									})}
								</ul>
							</div>
						)}
						<Actions className="pipsy__actions">
							{activeLot.latitude && (
								<>
									<CTA
										className="pipsy__cta--viewDirections"
										onClick={() => {
											setDirectionsModalOpen(true)
											fireEvent(
												{
													type: "viewDirections",
													data: activeLot.address,
													name: activeLot.address,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										<FontAwesomeIcon icon={faLocationArrow} color={"#bbb"} />
										VIEW DIRECTIONS
									</CTA>
									{simpleText && (
										<CTA className="disableHover">
											<TextingModule
												onChange={setSimpleText}
												simple={true}
												property={props.data.property}
											/>
										</CTA>
									)}
									{!simpleText && (
										<CTA
											onClick={() => {
												fireEvent(
													{
														type: "textDirectionsButton",
														data: activeLot.address,
														name: activeLot.address,
													},
													lastEvent,
													setLastEvent,
													{ domain, pipsyClient, propertyID }
												)
												setSimpleText(true)
											}}
											className="pipsy__cta--text">
											<FontAwesomeIcon icon={faLocationArrow} color={"#bbb"} />
											TEXT DIRECTIONS
										</CTA>
									)}
								</>
							)}
							{activeLot && activeLot.model && activeLot.virtual && (
								<CTA
									href={activeLot.virtual}
									target="_blank"
									onClick={() => {
										fireEvent(
											{
												type: "virtualTour",
												data: activeLot.address,
												name: activeLot.address,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
										if (
											activeLot?.virtual?.includes("youtube") ||
											activeLot?.virtual?.includes("google.com")
										) {
											window.open(activeLot?.virtual, "_blank")
											return
										}
										setVirtualLink(activeLot.virtual)
										setVirtualModal(true)
									}}
									className="pipsy__cta--virtualTour">
									<FontAwesomeIcon icon={faBinoculars} color={"#bbb"} />
									VIRTUAL TOUR
								</CTA>
							)}
							{activeLot && activeLot.floorplan_images && activeLot.floorplan_images.length > 0 && (
								<CTA
									className="pipsy__cta--viewFloorplan"
									onClick={() => {
										setBlueprintsOpen(true)
										fireEvent(
											{
												type: "viewFloorplanButton",
												data: activeLot.address || `${activeLot.name} - ${activeLot.builder}`,
												name: activeLot.address || `${activeLot.name} - ${activeLot.builder}`,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}>
									<FontAwesomeIcon icon={faFilePdf} color={"#bbb"} />
									VIEW FLOOR PLAN
								</CTA>
							)}
							{requestInfo}
							{!favorites.includes(favoriteID) && (
								<CTA
									className="pipsy__favorite"
									onClick={() => {
										props.storeFavorite(favoriteID)
										fireEvent(
											{
												type: "favorite",
												data:
													viewing == "homes"
														? activeLot.address
														: `${activeLot.name} - ${activeLot.builder}`,
												name:
													viewing == "homes"
														? activeLot.address
														: `${activeLot.name} - ${activeLot.builder}`,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}>
									<FontAwesomeIcon icon={faHeart} color={"#e63702"} />
									FAVORITE
								</CTA>
							)}
							{favorites.includes(favoriteID) && (
								<CTA
									className="pipsy__unfavorite"
									onClick={() => {
										props.removeFavorite(favoriteID)
										fireEvent(
											{
												type: "unfavorite",
												data:
													viewing == "homes"
														? activeLot.address
														: `${activeLot.name} - ${activeLot.builder}`,
												name:
													viewing == "homes"
														? activeLot.address
														: `${activeLot.name} - ${activeLot.builder}`,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}>
									<FontAwesomeIcon icon={faHeartFilled} color={"#e63702"} />
									UNFAVORITE
								</CTA>
							)}
							<CTA className="pipsy__share" onClick={() => shareClick()}>
								<FontAwesomeIcon icon={faShareSquare} color={"#bbb"} />
								{shareText}
							</CTA>
						</Actions>
						<LotPlans />
						{openHouse}
						{activeLot.marketing_description && (
							<Copy>
								<p>{decode(stripHTML(activeLot.marketing_description))}</p>
							</Copy>
						)}
					</Container>
					<Modal
						open={virtualModal}
						onClose={() => {
							setVirtualModal(false)
						}}
						center
						styles={{ modal: { width: "80%", maxWidth: "none", margin: "0 auto", height: "70vh" } }}>
						<FrameContainer>
							<iframe
								src={virtualLink}
								width="100%"
								height="100%"
								frameBorder="0"
								allowFullScreen></iframe>
						</FrameContainer>
					</Modal>
				</Panel>
			)
		} else {
			return ""
		}
	}

	let stripHTML = (str) => {
		let f = str.replace(/(<([^>]+)>)/gi, "")
		f = f.replace("&nbsp;", "")

		return f
	}

	let shareClick = () => {
		let url = `${window.location.origin}${window.location.pathname}`
		let string
		try {
			if (activeLot.address) {
				const hasNumber = (str) => /\d/.test(str)
				fireEvent(
					{
						type: "shareURL",
						data: activeLot.address,
						name: null,
					},
					lastEvent,
					setLastEvent,
					{ domain, pipsyClient, propertyID }
				)
				// Sharing a home
				if (url.includes("localhost") && !hasNumber(activeLot.address)) {
					string = `${window.location.href}&lot_id=${activeLot.id}`
				} else if (url.includes("localhost")) {
					string = `${window.location.href}&address=${encodeURIComponent(activeLot.address)}`
				} else if (hasNumber(activeLot.address)) {
					string = `${url}?address=${encodeURIComponent(activeLot.address)}`
				} else if (!hasNumber(activeLot.address)) {
					// Scenario like Georges ranch where they dont have addresses until it sells.
					string = `${url}?lot_id=${activeLot.id}`
				}
			} else {
				let str
				if (activeLot.feed_name) str = activeLot.feed_name.replaceAll(" ", "+")
				else str = activeLot.name.replaceAll(" ", "+")
				if (url.includes("localhost")) {
					string = `${window.location.href}&floorplan=${str}`
				} else string = `${url}?floorplan=${str}`
				fireEvent(
					{
						type: "shareURLFloorplan",
						data: `${activeLot.name} - ${activeLot.builder}`,
						name: null,
					},
					lastEvent,
					setLastEvent,
					{ domain, pipsyClient, propertyID }
				)
			}

			if (navigator && navigator.clipboard) {
				navigator.clipboard.writeText(string)
				setShareText("URL COPIED!")
				setTimeout(() => {
					setShareText("SHARE URL")
				}, 3000)
			} else {
				alert("URL: " + string)
			}
		} catch (e) {
			console.log(e)
		}
	}

	let downloadCalendar = (v) => {
		try {
			let startStamp = v.startStamp
			let endStamp = v.endStamp
			let str = `BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//Pipsy//EN\nBEGIN:VTIMEZONE\nTZID:America/Chicago\nBEGIN:DAYLIGHT\nTZOFFSETFROM:-0600\nRRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU\nDTSTART:20070311T020000\nTZNAME:CDT\nTZOFFSETTO:-0500\nEND:DAYLIGHT\nBEGIN:STANDARD\nTZOFFSETFROM:-0500\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU\nDTSTART:20071104T020000\nTZNAME:CST\nTZOFFSETTO:-0600\nEND:STANDARD\nEND:VTIMEZONE\nBEGIN:VEVENT\nUID:pipsy-${activeLot.id}\nDTSTAMP;TZID=America/Chicago:${startStamp}\nDTSTART;TZID=America/Chicago:${startStamp}\nDTEND;TZID=America/Chicago:${endStamp}\nSUMMARY:Open House for ${activeLot.address}\nGEO:${activeLot.latitude};${activeLot.longitude}\nLOCATION: https://maps.google.com?q=${activeLot.latitude}\\,${activeLot.longitude}\nEND:VEVENT\nEND:VCALENDAR`
			const file = new File([str], "open-house.ics", {
				type: "text/plain",
			})
			let download = () => {
				const link = document.createElement("a")
				const url = URL.createObjectURL(file)

				link.href = url
				link.download = file.name
				document.body.appendChild(link)
				link.click()

				document.body.removeChild(link)
				window.URL.revokeObjectURL(url)
			}
			download()
		} catch (e) {
			console.log(e)
		}
	}

	let Counters = (p) => {
		if (viewing === p.type) return <Count>{matchedList.length}</Count>
		if (p.type === "homes") {
			let c = props.buildMatchLists({ justCount: true, viewing: "homes" })
			return <Count>{c}</Count>
		}
		if (p.type === "floorplans") {
			let c = props.buildMatchLists({ justCount: true, viewing: "floorplans" })
			return <Count>{c}</Count>
		}
		if (p.type === "models") {
			let c = props.buildMatchLists({ justCount: true, viewing: "models" })
			return <Count>{c}</Count>
		}
		if (p.type === "openHouses") {
			let c = props.buildMatchLists({ justCount: true, viewing: "openHouses" })
			return <Count>{c}</Count>
		}
		if (p.type === "lot_finder") {
			let c = props.buildMatchLists({ justCount: true, viewing: "lot_finder" })
			return <Count>{c}</Count>
		}
		if (p.type === "area_features") {
			try {
				let count = filter(props.data.area_features, (v) => !v.amenity)
				return <Count>{count?.length}</Count>
			} catch (e) {
				console.log(e)
			}
		}
		if (p.type === "amenities") {
			try {
				let count = filter(props.data.area_features, (v) => v.amenity)
				return <Count>{count?.length}</Count>
			} catch (e) {
				console.log(e)
			}
		}
		return ""
	}

	let LotPlans = () => {
		if (activeLot.lot_status !== "Available Lot") return ""
		let plans = filter(props.data.floorplans, (v) => {
			if (!v.status) return false
			let pass = false
			forEach(v.lot_types, (r) => {
				if (r.lot_type === activeLot.lot_type_id && v.builder_id === activeLot.builder_id) pass = true
			})
			if (pass) return true
		})
		if (plans.length === 0) return ""
		return (
			<LotPlansBlock>
				<LotPlansTitle>Floor Plans</LotPlansTitle>
				<LotPlansList>
					{map(plans, (v, k) => {
						let planInfo = []
						if (v.beds) planInfo.push(<li key={`beds-${v.id}`}>{v.beds} Beds</li>)
						if (v.full_baths) planInfo.push(<li key={`full-${v.id}`}>{v.full_baths} Full Baths</li>)
						if (v.half_baths) planInfo.push(<li key={`half-${v.id}`}>{v.half_baths} Half Baths</li>)
						if (v.garage) planInfo.push(<li key={`garage-${v.id}`}>{v.garage} Garage</li>)
						if (v.stories) planInfo.push(<li key={`stories-${v.id}`}>{v.stories} Stories</li>)
						if (v.sqft) planInfo.push(<li key={`sqft-${v.id}`}>{v.sqft} Sqft</li>)
						let img = (
							<LazyLoad height={`22vh`}>
								<Image
									v={v}
									onClick={() => {
										if (v.images && v.images.length > 0) {
											setFloorplanImages(v.images)
											setFloorplanIndex(0)
											setFloorplanOpen(true)
										}
									}}>
									{!v.images || (Array.isArray(v?.images) && v.images.length === 0) ? (
										<Missing>No Image Available</Missing>
									) : null}
								</Image>
							</LazyLoad>
						)
						return (
							<LotPlan key={`lotPlan-${k}-${v.id}`}>
								{img}
								<LotPlanName>{v.feed_name}</LotPlanName>
								<LotPlanInfo>
									{planInfo?.length ? <LotPlanFeatures>{planInfo}</LotPlanFeatures> : ""}
								</LotPlanInfo>
							</LotPlan>
						)
					})}
				</LotPlansList>
			</LotPlansBlock>
		)
	}

	let buildSortOptions = () => {
		let options = ["Price", "Move In Date", "Square Footage", "Beds", "Stories"]
		let ret = []
		if (props?.data?.custom?.personalize?.defaultSort) {
			let opts = filter(options, (o) => o !== props.data.custom.personalize.defaultSort)
			options = [props.data.custom.personalize.defaultSort, ...opts]
		}
		forEach(options, (o) => {
			ret.push(
				<div
					className={`pipsy__sortOption px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
						sort === o ? "bg-gray-50" : ""
					}`}
					onClick={() => {
						setSort(o)
						setSortMenuOpen(false)
					}}>
					{o}
				</div>
			)
		})
		return ret
	}

	try {
		let lot = activeLot.images
		// Check for manual where we have { url and type }
		if (Array.isArray(lot) && lot.length > 0 && lot[0].url) {
			lot = map(lot, (v) => v.url)
		}
		let blueprints = activeLot.floorplan_images ? activeLot.floorplan_images : []
		let property = props.data.property
		//if(!property) return <></>
		let floorplanTitle = `FLOOR PLANS`
		if (property?.floorplanSpaceName) floorplanTitle = "FLOORPLANS"
		let headerCSS = `m-0 font-normal text-[14px] cursor-pointer p-[10px_5px]  box-border basis-1/2 text-center border-b border-b-solid border-[#ccc] xl:text-[16px] lg:odd:border-r lg:odd:border-r-gray-300`
		let typeSelect = () => {
			// Only lot finder
			if (mode === "builderDetail") return null
			if (mode === "lot_finder") {
				return (
					<>
						<TypeSelect className="pipsy__typeSelect" activePanel={activePanel}>
							<h2
								className={`${
									"lot_finder" === viewing
										? `bg-[var(--pipsy-communityColor)] text-white`
										: `bg-white text-primary`
								} ${headerCSS} pipsy__buttonHomesites`}
								onClick={() => {
									setScrollPos(0)
									setViewing("lot_finder")
								}}>
								AVAILABLE HOMESITES <Counters type="lot_finder" data={props.data} />
							</h2>
						</TypeSelect>
					</>
				)
			}
			return (
				<>
					{mode !== "area_features" ? (
						<TypeSelect className="pipsy__typeSelect" activePanel={activePanel}>
							{get(property, `disabled.availableHomes`) ? (
								""
							) : (
								<h2
									className={`${
										"homes" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonHomes`}
									onClick={() => {
										setScrollPos(0)
										setViewing("homes")
									}}>
									AVAILABLE HOMES <Counters type="homes" data={props.data} />
								</h2>
							)}
							{get(property, `disabled.floorplans`) ? (
								""
							) : (
								<h2
									className={`${
										"floorplans" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonFloorplans`}
									onClick={() => {
										setScrollPos(0)
										setViewing("floorplans")
									}}>
									{floorplanTitle} <Counters type="floorplans" data={props.data} />
								</h2>
							)}
							{get(property, `disabled.models`) ? (
								""
							) : (
								<h2
									className={`${
										"models" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonModels`}
									onClick={() => {
										setScrollPos(0)
										setViewing("models")
									}}>
									MODELS <Counters type="models" data={props.data} />
								</h2>
							)}
							{get(property, `enabled.openHouses`) && (
								<h2
									className={`${
										"openHouses" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonOpenHouses`}
									onClick={() => {
										setScrollPos(0)
										setViewing("openHouses")
									}}>
									OPEN HOUSES <Counters type="openHouses" data={props.data} />
								</h2>
							)}
							{property.amenities && (
								<h2
									className={`${
										"amenities" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonAmenities`}
									onClick={() => {
										setScrollPos(0)
										setViewing("amenities")
									}}>
									AMENITIES
									<Counters type="amenities" data={props.data} />
								</h2>
							)}
							{property.area_features && (
								<h2
									className={`${
										"area_features" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonAreaFeatures`}
									onClick={() => {
										setScrollPos(0)
										setViewing("area_features")
									}}>
									AREA FEATURES <Counters type="area_features" data={props.data} />
								</h2>
							)}
							{property.lot_finder && (
								<h2
									className={`${
										"lot_finder" === viewing
											? `bg-[var(--pipsy-communityColor)] text-white`
											: `bg-white text-primary`
									} ${headerCSS} pipsy__buttonHomesites`}
									onClick={() => {
										setScrollPos(0)
										setViewing("lot_finder")
									}}>
									AVAILABLE HOMESITES <Counters type="lot_finder" data={props.data} />
								</h2>
							)}
						</TypeSelect>
					) : null}
				</>
			)
		}
		return (
			<>
				<div
					className={`pipsy__publicListCont relative h-full overflow-hidden ${
						activePanel && !isMobile ? "hidden" : activePanel && isMobile ? "block" : "flex"
					} flex-col`}>
					<>
						<div
							className={`lg:flex absolute right-0 items-start cursor-pointer ${
								props?.data?.property?.enabled?.hideMapButton ? "flex" : "hidden"
							}`}
							onClick={() => {
								setShowMap(!showMap)
								setManualMapShow(!manualMapShow)
								fireEvent(
									{
										type: "hideMap",
										data: showMap ? false : true,
										name: null,
									},
									lastEvent,
									setLastEvent,
									{ domain, pipsyClient, propertyID }
								)
							}}>
							<div className="bg-[#eee] box-content p-[3px_5px]">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 640 512"
									className={classNames("w-4 fill-[#999]", {
										"rotate-180": !showMap,
									})}>
									<path d="M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96zM279.5 409.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-72 288 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-288 0 0-72c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136c-4.8 4.5-7.5 10.8-7.5 17.4s2.7 12.9 7.5 17.4l144 136z" />
								</svg>
							</div>
						</div>
						{typeSelect()}
						{viewing == "homes" && (
							<HomesOptions activePanel={activePanel}>
								<HomeOptionsBox>
									<HomesOption
										className="pipsy__moveInReady"
										onClick={() => {
											setMoveIn(!moveIn)
											fireEvent(
												{
													type: "moveIn",
													data: moveIn ? false : true,
													name: null,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										<FontAwesomeIcon
											icon={moveIn ? faCheckCircle : faCheckCircleRegular}
											color={props.theme.color}
										/>
										Move-in Ready
									</HomesOption>
									<HomesOption
										className="pipsy__underConstruction"
										onClick={() => {
											setUnderConst(!underConst)
											fireEvent(
												{
													type: "underConstruction",
													data: underConst ? false : true,
													name: null,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										<FontAwesomeIcon
											icon={underConst ? faCheckCircle : faCheckCircleRegular}
											color={props.theme.color}
										/>
										Under Construction
									</HomesOption>
								</HomeOptionsBox>
								<div className="pt-2 lg:pt-0">
									<span>Sort By:</span>
									<div className="relative inline-block text-left ml-2 z-[180]">
										<div
											className="cursor-pointer px-3 py-1 border border-gray-300 rounded flex items-center"
											onClick={() => {
												setSortMenuOpen(!sortMenuOpen)
											}}>
											{sort}
											<svg
												className="w-4 h-4 ml-2"
												fill="none"
												stroke="currentColor"
												viewBox="0 0 24 24">
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth={2}
													d="M19 9l-7 7-7-7"
												/>
											</svg>
										</div>

										<div
											className={`${
												sortMenuOpen ? "block" : "hidden"
											} absolute right-0 mt-2 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50`}>
											<div className="py-1">{buildSortOptions()}</div>
										</div>
									</div>
								</div>
							</HomesOptions>
						)}
						{viewing == "lot_finder" && props?.data?.property?.enabled?.premiumHomesites && (
							<HomesOptions activePanel={activePanel}>
								<HomeOptionsBox>
									<HomesOption
										className="pipsy__premiumHomesites"
										onClick={() => {
											setPremiumHomesites(!premiumHomesites)
											fireEvent(
												{
													type: "premiumHomesites",
													data: premiumHomesites ? false : true,
													name: null,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										<FontAwesomeIcon
											icon={premiumHomesites ? faCheckCircle : faCheckCircleRegular}
											color={props.theme.color}
										/>
										Premium Homesites
									</HomesOption>
									<HomesOption
										className="pipsy__builderOwned"
										onClick={() => {
											setBuilderOwnedHomesites(!builderOwnedHomesites)
											fireEvent(
												{
													type: "builderOwned",
													data: builderOwnedHomesites ? false : true,
													name: null,
												},
												lastEvent,
												setLastEvent,
												{ domain, pipsyClient, propertyID }
											)
										}}>
										<FontAwesomeIcon
											icon={builderOwnedHomesites ? faCheckCircle : faCheckCircleRegular}
											color={props.theme.color}
										/>
										Builder Owned Homesites
									</HomesOption>
								</HomeOptionsBox>
							</HomesOptions>
						)}
						{(viewing == "amenities" || viewing == "area_features") && (
							<HomesOptions>
								<HomeOptionsBox>
									<HomesOption className="pipsy__flyBack" onClick={() => setFlyBack(true)}>
										<FontAwesomeIcon icon={faUndo} color={props.theme.color} />
										Fly Back to {property.marketing_name || property.name}
									</HomesOption>
								</HomeOptionsBox>
							</HomesOptions>
						)}
						{isMobile && (
							<div id="pipsy__map" className={`${showMap ? "block" : "hidden"} h-full outline-0`}>
								<PublicMap key="mobileMap" data={props.data} theme={props.theme} isMobile={true} />
							</div>
						)}
						<ul
							ref={list}
							className={classNames(
								`pipsy__list list-none m-0 p-0 overflow-y-scroll md:grid md:grid-cols-2 bg-white !opacity-100`,
								{
									block: activePanel === false,
									hidden:
										activePanel === true || viewing === "amenities" || viewing === "area_features",
									"xl:grid-cols-4": !showMap,
									"xl:grid-cols-2": showMap,
								}
							)}>
							<BuildList />
						</ul>
						{matchedList.length == 0 ? <NoResults>No results match your filter criteria.</NoResults> : ""}
						{["amenities", "area_features"].includes(viewing) && selectedAreaFeatures.length === 0 ? (
							<NoResults>No results match your filter criteria.</NoResults>
						) : (
							""
						)}
					</>
				</div>
				<GeneratePanel />
				{imageOpen && (
					<Lightbox
						animationDuration={0}
						mainSrc={lot[imageIndex]}
						nextSrc={lot[(imageIndex + 1) % lot.length]}
						prevSrc={lot[(imageIndex + lot.length - 1) % lot.length]}
						onCloseRequest={() => {
							setImageIndex(0)
							setImageOpen(false)
						}}
						onMovePrevRequest={() => {
							setImageIndex((imageIndex + lot.length - 1) % lot.length)
						}}
						onMoveNextRequest={() => setImageIndex((imageIndex + 1) % lot.length)}
						reactModalStyle={{
							overlay: {
								zIndex: 99999,
							},
						}}
					/>
				)}
				{blueprintsOpen && (
					<Lightbox
						animationDuration={0}
						mainSrc={blueprints[blueprintIndex]}
						nextSrc={blueprints[(blueprintIndex + 1) % blueprints.length]}
						prevSrc={blueprints[(blueprintIndex + blueprints.length - 1) % blueprints.length]}
						onCloseRequest={() => {
							setBlueprintIndex(0)
							setBlueprintsOpen(false)
						}}
						onMovePrevRequest={() => {
							setBlueprintIndex((blueprintIndex + blueprints.length - 1) % blueprints.length)
						}}
						onMoveNextRequest={() => setBlueprintIndex((blueprintIndex + 1) % blueprints.length)}
						reactModalStyle={{
							overlay: {
								zIndex: 99999,
							},
						}}
					/>
				)}
				{floorplanOpen && (
					<Lightbox
						animationDuration={0}
						mainSrc={floorplanImages[floorplanIndex]}
						nextSrc={floorplanImages[(floorplanIndex + 1) % floorplanImages.length]}
						prevSrc={
							floorplanImages[(floorplanIndex + floorplanImages.length - 1) % floorplanImages.length]
						}
						onCloseRequest={() => {
							setFloorplanIndex(0)
							setFloorplanOpen(false)
						}}
						onMovePrevRequest={() => {
							setFloorplanIndex((floorplanIndex + floorplanImages.length - 1) % floorplanImages.length)
						}}
						onMoveNextRequest={() => setFloorplanIndex((floorplanIndex + 1) % floorplanImages.length)}
						reactModalStyle={{
							overlay: {
								zIndex: 99999,
							},
						}}
					/>
				)}
				{directionsModalOpen ? (
					<Suspense fallback={<div>Loading</div>}>
						<DirectionsModule
							open={directionsModalOpen}
							onClose={() => setDirectionsModalOpen(false)}
							coords={`${activeLot.latitude},${activeLot.longitude}`}
						/>
					</Suspense>
				) : null}
			</>
		)
	} catch (e) {
		console.log(e)
		return <div></div>
	}
}

export default PublicList
